/**
 * SearchContentTagsUseCase
 *
 * Searches content tags by prefix with pagination.
 * Matches Flutter's search_screen.dart searchContentTags logic.
 */

import type { PageCursor } from '@/data/types/json';
import { ContentTagService } from '@/domain/services/contentTag/contentTagService';
import type { ContentTagEntity } from '@/domain/entities/contentTag/contentTagEntity';

export interface SearchContentTagsResult {
  contentTags: ContentTagEntity[];
  hasMore: boolean;
  cursor?: PageCursor;
}

export class SearchContentTagsUseCase {
  private contentTagService: ContentTagService;

  constructor() {
    this.contentTagService = ContentTagService.getInstance();
  }

  async execute(
    prefix: string,
    cursor?: PageCursor,
    limitCount: number = 8
  ): Promise<SearchContentTagsResult> {
    const result = await this.contentTagService.searchContentTags(
      prefix,
      cursor,
      limitCount
    );

    return {
      contentTags: result.contentTags,
      hasMore: result.hasMore,
      cursor: result.cursor,
    };
  }
}

export const createSearchContentTagsUseCase = () => new SearchContentTagsUseCase();
